<template>
    <div>
        

        <LanguageTable
            title="Users"
            @addRoster="showLanguageModal"
            ref="table"
        >
       
    </LanguageTable>
        
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import LanguageTable from './LanguageTable'

// import CreateVehicleForm from './CreateVehicleForm'

export default {
    name: 'Language',
    mixins: [popupMixins, permissionsMixins],
    components: {
        LanguageTable,
        
    },
    data: () => {
        return {
            item: null,
          
        }
    },
    async mounted(){
        // await this.$store.dispatch('language/fetchUsers');
    },
    methods: {
        alertSuccess(action) {
            console.log("asdasda",action)
            console.log(this.item)
            this.genericToast(
                this.componentName,
                action,
                'success',
                `${name} has been succcessfully ${action.toLowerCase()}`
            )
            //this.doToast('Success', `Item ${action}!`, 'success')
            this.item = null
            this.$refs.table.doSearch()
        },
        showLanguageModal() {
            this.$refs.createDocumentType.showModal()
        },
        // created() {
        //     this.doToast('Created!', 'Vehicle Created', 'success')
        //     this.$refs.table.doSearch()
        //     this.$refs.createVehicle.hideModal()
        // },
        handleError(error) {
            this.doToast(this.$translate('error'), error.message, 'danger')
        },
      
    },
}
</script>
<style></style>
